export const SocketSignals = {
  JOIN_SESSION: "join-session",
  START_SESSION: "start-session",
  SELECTED_SONG: "selected-song",
  END_SESSION: "end-session",

  SESSION_STARTED: "session-started",
  LIVE_SONG: "live-song",
  SESSION_ENDED: "session-ended",
}
